import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges, TemplateRef } from '@angular/core';

import { Images } from './images';

export type IntegrationImage = keyof typeof Images;

@Component({
  selector: 'rti-svg-asset',
  templateUrl: './svg-asset.component.html',
  styleUrls: ['./svg-asset.component.less'],
  standalone: true,
  imports: [CommonModule],
})
export class SvgAssetComponent {
  public template: TemplateRef<any>;
  public assetPath: string;

  @Input() public name: IntegrationImage;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.name) {
      this.updateAsset(this.name);
    }
  }

  private updateAsset(name: IntegrationImage) {
    const path = Images[name];
    if (!path) {
      // eslint-disable-next-line no-console
      console.info(`There is no image for ${name}`);
    }
    this.assetPath = `assets/integrations/images/${path}`;
  }
}
